import '@fortawesome/fontawesome-free/css/brands.min.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import { createVuetify, type ThemeDefinition } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, fa } from 'vuetify/iconsets/fa';
import { es } from 'vuetify/locale';
import 'vuetify/styles';

const customTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#f5f5f7',
    surface: '#fff',
    white: '#fff',
    primary: '#008080',
    tealBlue: '#247ba0',
    darkTealBlue: '#305F72',
    teal: '#008080',
    lightTeal: '#7DDFC3',
    darkGreen: '#226357',
    green: '#32936f',
    lightGreen: '#85A93F',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#f44336',
    orange: '#F2804C',
    lightOrange: '#FFCC80',
    blue: '#0084F4',
    lightBlue: '#66b5f8',
    lightestBlue: '#deebfc',
    darkIndigo: '#0052A4',
    indigo: '#5383D3',
    pink: '#FF647C',
    darkPurple: '#9C27B1',
    purple: '#BE52F2',
    lightPurple: '#DBA5F5',
    lightestPurple: '#e8d3f3',
    yellow: '#FFDE63',
    darkYellow: '#FFCB61',
    lightestRed: '#ff7b7b',
    lightRed: '#ff5252',
    red: '#F44336',
    dustyViolet: '#805E73',
    lightestGray2: '#FBFBFB',
    lightestGray: '#F6F6F6',
    lightGray: '#D4D4D4',
    midGray: '#666',
    midGray2: '#9e9e9e',
    darkGray: '#4d4d4d',
    slateGray: '#4f5d75',
    blackFlat: '#262626',
  },
};

export default createVuetify({
  components,
  directives,
  defaults: {
    VTextField: {
      variant: 'underlined',
      color: 'teal',
      density: 'comfortable',
      class: 'medium-font',
    },
    VTextarea: {
      variant: 'underlined',
      color: 'teal',
      density: 'comfortable',
      class: 'medium-font',
    },
    VSelect: {
      variant: 'underlined',
      color: 'teal',
      density: 'comfortable',
      class: 'medium-font',
    },
    VAutocomplete: {
      variant: 'underlined',
      color: 'teal',
      density: 'comfortable',
      class: 'medium-font',
    },
    VCombobox: {
      variant: 'underlined',
      color: 'teal',
      density: 'comfortable',
      class: 'medium-font',
    },
    VFileInput: {
      variant: 'underlined',
      color: 'teal',
      density: 'comfortable',
      class: 'cursor-pointer medium-font',
    },
    VBtn: {
      variant: 'flat',
    },
  },
  icons: {
    defaultSet: 'fa',
    aliases,
    sets: {
      fa,
    },
  },
  locale: {
    locale: 'es',
    messages: { es },
  },
  theme: {
    defaultTheme: 'customTheme',
    themes: {
      customTheme: customTheme,
    },
  },
});
